import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Editor from "../../components/Editor";
import CurrencyPicker from "../../main/component/CurrencyPicker";
import NumericFormatFieldDebounce from "../../components/ui/NumericFormatFieldDebounce";

const PriceForm = ({
  eventData,
  onDataChange,
  onChangeMentionedMembers,
  validationErrors: _validationErrors,
  editorInputDescriptionRef,
}) => {
  const { t } = useTranslation();

  const members = useSelector((state: any) => state.projectReducer.getIn(["project", "members"]));

  const handleChangeField = (fieldId, fieldValue) => {
    onDataChange(fieldId, fieldValue);
  };

  return (
    <div className="min-w-2xl space-y-4">
      <div>
        <CurrencyPicker
          currencyCode={eventData.currency}
          onChange={(currency: string) => {
            handleChangeField("currency", currency);
          }}
        />
      </div>
      <div>
        <NumericFormatFieldDebounce
          label={t("Unit price")}
          value={eventData.unitPrice}
          onChange={(value: string) => {
            handleChangeField("unitPrice", value);
          }}
          placeholder={t("Set a value")}
          currency={eventData.currency}
        />
      </div>
      <div>
        <div className="w-full">
          <label className="block text-sm font-semibold text-gray-800 mb-2">{t("Comments")}</label>
          <div className="max-w-2xl rounded-lg border border-gray-300 [&_.ql-container]:!border-0">
            <Editor
              editorInputRef={editorInputDescriptionRef}
              showToolbar={false}
              minRows={4}
              members={members}
              editorContent={{
                htmlContent: eventData.description,
                contents: {},
              }}
              onChange={(content) => {
                onChangeMentionedMembers(content.mentionedMembers);
                handleChangeField("description", content.htmlContent);
              }}
              placeholder={t("Type comment...")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceForm;
